import _ from 'lodash';

export const selectContactForm = state => _.get(state, ['contactForm'], {});

export const selectContactFormData = state => _.get(selectContactForm(state), ['data'], {});
